import React from 'react';
import DocumentProcessingForm from '../../components/DocumentProcessingForm';

function DocumentProcessing() {
  return <DocumentProcessingForm />;
}

export default DocumentProcessing;
